import React from "react";
import { BRAND } from "../config";

const CONTENT = {
  cgv: {
    title: "Conditions Générales de Vente",
    sub: "CGV — La Boutique d'Esther",
    body: [
      ["Article 1 — Objet", "Les présentes conditions régissent les ventes réalisées par La Boutique d'Esther, boutique de mode féminine en ligne basée en Guadeloupe (971), auprès de ses clientes."],
      ["Article 2 — Produits", "Les produits proposés sont ceux figurant sur le site, dans la limite des stocks disponibles. Les photographies sont les plus fidèles possibles mais ne peuvent assurer une similitude parfaite (couleurs notamment)."],
      ["Article 3 — Prix", "Les prix sont indiqués en euros (€) toutes taxes comprises. La Boutique d'Esther se réserve le droit de modifier ses prix à tout moment, les produits étant facturés sur la base des tarifs en vigueur au moment de la commande."],
      ["Article 4 — Commande", "La commande peut être passée en ligne via le panier ou via WhatsApp. Toute commande vaut acceptation des présentes CGV. Un email de confirmation est envoyé après validation."],
      ["Article 5 — Paiement", "Le paiement s'effectue à la livraison ou via WhatsApp. Le paiement en ligne (CB / PayPal) sera proposé prochainement."],
      ["Article 6 — Livraison", "Les articles en stock sont livrés en Guadeloupe sous 2 à 5 jours ouvrés. Les frais de livraison sont calculés selon le poids total de la commande : 13€ (0-300g), 16€ (300-600g), 20€ (600g-1kg) et 25€ au-delà d'1kg."],
      ["Article 7 — Rétractation & Retours", "Vous disposez d'un délai de 7 jours pour retourner un article non porté dans son état d'origine. Les articles d'hygiène (lingerie, maillots de bain) ne sont pas retournables."],
      ["Article 8 — Service client", `Pour toute question : WhatsApp ${BRAND.whatsappDisplay} ou email ${BRAND.email}.`],
    ],
  },
  mentions: {
    title: "Mentions Légales",
    sub: "Informations légales",
    body: [
      ["Éditeur du site", "La Boutique d'Esther — Boutique de mode féminine, Guadeloupe (971), Antilles françaises."],
      ["Contact", `WhatsApp : ${BRAND.whatsappDisplay} — Email : ${BRAND.email} — Instagram : ${BRAND.instagramHandle}`],
      ["Hébergement", "Le site est hébergé sur une infrastructure cloud sécurisée."],
      ["Propriété intellectuelle", "L'ensemble des contenus du site (textes, visuels, logo) est la propriété de La Boutique d'Esther, sauf mention contraire. Toute reproduction est interdite sans autorisation."],
      ["Responsabilité", "La Boutique d'Esther s'efforce d'assurer l'exactitude des informations diffusées mais ne saurait être tenue responsable des erreurs ou omissions."],
    ],
  },
  confidentialite: {
    title: "Politique de Confidentialité",
    sub: "Protection de vos données",
    body: [
      ["Données collectées", "Nous collectons uniquement les données nécessaires au traitement de vos commandes et à votre inscription à la newsletter : nom, email, téléphone, adresse de livraison."],
      ["Utilisation", "Vos données servent exclusivement à traiter vos commandes, vous informer de leur suivi et, avec votre accord, vous envoyer nos actualités et offres."],
      ["Conservation", "Vos données sont conservées le temps nécessaire à la relation commerciale et à nos obligations légales."],
      ["Vos droits", `Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Contactez-nous à ${BRAND.email}.`],
      ["Partage", "Vos données ne sont jamais vendues. Elles peuvent être partagées avec nos prestataires de livraison et d'emailing dans le strict cadre du service."],
    ],
  },
  cookies: {
    title: "Politique de Cookies",
    sub: "Utilisation des cookies",
    body: [
      ["Qu'est-ce qu'un cookie ?", "Un cookie est un petit fichier déposé sur votre appareil lors de la visite du site, permettant d'améliorer votre expérience."],
      ["Cookies utilisés", "Nous utilisons des cookies techniques (panier, session) indispensables au fonctionnement du site, ainsi que des cookies de mesure d'audience."],
      ["Gestion", "Vous pouvez accepter ou refuser les cookies via la bannière affichée à votre première visite, ou configurer votre navigateur pour les bloquer."],
      ["Consentement", "En poursuivant votre navigation après avoir accepté la bannière, vous consentez à l'utilisation des cookies décrits."],
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type] || CONTENT.mentions;
  return (
    <div data-testid={`legal-${type}`}>
      <div className="bg-noir text-center py-16 px-6 grain relative">
        <h1 className="font-display text-4xl md:text-5xl text-white relative">{c.title}</h1>
        <p className="font-serif-el italic text-dore text-lg mt-2 relative">{c.sub}</p>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-14 space-y-8">
        {c.body.map(([h, p], i) => (
          <div key={i}>
            <h2 className="font-display text-xl text-encre mb-2">{h}</h2>
            <p className="text-ardoise text-sm leading-relaxed">{p}</p>
          </div>
        ))}
        <p className="text-ardoise/50 text-xs pt-6 border-t border-dore/15">Dernière mise à jour : 2024 — La Boutique d'Esther, Guadeloupe 971.</p>
      </div>
    </div>
  );
}
